import "./custom-checkbox.scss";
import { useState, useEffect, useRef, Fragment} from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";

export interface IProps {
  text: string;
  id: string;
  initialValue?: boolean;
  readOnlyState?: boolean;
  disabled?: boolean;
  name?: string;
  simple?: boolean;
  selectedColor?: string,
  defaultColor?: string;
  handleOnSelectRole(id: string, role: string, status: boolean): void;
  setLastSelectedPicker?(id:string | undefined): void;
  lastSelectedPicker?: string;
  withInnerHeight?: string;
  noEmptySelection?: boolean;
  handleOnSelectColumnColor?(key: string, color: string, defaultColor: undefined | string): void;
}

function useOutsideAlerter(ref:any, setToggleColorPicker: any) { // eslint-disable-line
  useEffect(() => {
    function handleClickOutside(event:any) { // eslint-disable-line
      if (
        event.target.className !== "react-colorful__interactive" && !ref.current.contains(event.target) && 
        event.target.className !== "colorpickerInput" && !ref.current.contains(event.target) &&
        event.target.className !== "react-colorful__pointer react-colorful__saturation-pointer" && !ref.current.contains(event.target) &&
        event.target.className !== "react-colorful__pointer" && !ref.current.contains(event.target) &&
        event.target.className !== "react-colorful__pointer react-colorful__hue-pointer" && !ref.current.contains(event.target)
      ) {
        setToggleColorPicker(false);
      }
    }
    // bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
const CustomCheckbox = ({ text, selectedColor, noEmptySelection, setLastSelectedPicker, withInnerHeight, lastSelectedPicker, defaultColor, handleOnSelectColumnColor, name, simple, disabled, initialValue, id, readOnlyState, handleOnSelectRole }: IProps) => {
  const [toggle, setToggle] = useState(false);
  const [color, setColor] = useState("");
  const [toggleColorPicker, setToggleColorPicker] = useState(false);

  const tooltipRef = useRef<HTMLElement>(null);
  useOutsideAlerter(tooltipRef, setToggleColorPicker);

  const scroller = withInnerHeight? document.querySelector(withInnerHeight) : 0;

  useEffect(() => {
    if (!color && defaultColor && !selectedColor) {
      // no color saved, no selected color => use default
      defaultColor && setColor(defaultColor);
    }
  }, [defaultColor, color, selectedColor]);

  useEffect(() => {
    if (!color || selectedColor !== defaultColor) {
      // set saved color on mount after we recive the settings
      selectedColor && setColor(selectedColor);
    }
  }, [selectedColor]);

  useEffect(() => {
    if (!toggleColorPicker) {
      setLastSelectedPicker && handleOnSelectColumnColor && handleOnSelectColumnColor(id, color, defaultColor);
    } else {
      selectedColor && setColor(color);
    }
  }, [toggleColorPicker, toggle]);

  useEffect(() => {
    if (initialValue) {
      setToggle(initialValue);
    } else {
      setToggle(false);
    }
  }, [initialValue]);

  useEffect(() => {
    if (lastSelectedPicker === "scrollAction") {
      setLastSelectedPicker && setToggleColorPicker(false);
    } 
    else if (id !== lastSelectedPicker && lastSelectedPicker !== undefined && lastSelectedPicker !== "") {
      // close if the last selected was not this one
      setLastSelectedPicker && setToggleColorPicker(false);
    } 
  }, [lastSelectedPicker]);

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    if (readOnlyState || disabled) {
      return;
    }
    if ((event.target as Element).id === id) {
      // outside arrow
      handleOnSelectRole(id, text, !toggle);
      !noEmptySelection && setToggle(prev => !prev);
    } else {
      // on arrow click
      if (!toggle) {
        // on initial arrow click => select
        setToggleColorPicker(true);
        handleOnSelectRole(id, text, true);
        !noEmptySelection && setToggle(true);
        setLastSelectedPicker && setLastSelectedPicker(id);
      } else {
        // if was selected on arrow click
        if (id === lastSelectedPicker && toggleColorPicker) {
          setLastSelectedPicker && setLastSelectedPicker("");
        }
        if (toggleColorPicker) {
          setToggleColorPicker(false);
        } else {
          setLastSelectedPicker && setLastSelectedPicker(id);
          setToggleColorPicker(true);
        }
      }
    }
  };

  return (
    <Fragment>
      <span
        onClick={event => handleOnClick(event)}
        id={id}
        ref={tooltipRef}
        data-name={name && name}
        style={{ backgroundColor: toggle ? color : "", borderColor: toggle ? color : "" }}
        className={`${simple ? "customCheckboxSimple" : "customCheckbox"}-${toggle ? "selected" : "blank"} ${disabled ? "disabled" : ""}`}
      >
        <span id={id} className={"customCheckbox-text"} role="customCheckbox" >
          {text}
          {setLastSelectedPicker && handleOnSelectColumnColor && 
          <span className="arrowWrapper" id={`arrow-${id}`}><i id={`arrow-${id}`} className={`arrow down ${toggle ? "selectedArrow" : "blankArrow"}`}></i></span>
          }
        </span>
        
      </span>
      {setLastSelectedPicker && toggleColorPicker  &&  tooltipRef.current && (
        <span
          style={{ top: tooltipRef?.current.offsetTop - (scroller? scroller?.scrollTop : 0)}} 
          className="customCheckbox-colorPickerWrapper"
        >
          <HexColorPicker color={color} onChange={setColor} />
          <HexColorInput className="colorpickerInput" color={color} onChange={setColor} />
        </span>
      )}
    </Fragment>
  );
};

export default CustomCheckbox;